import { Button } from "@/components/core/buttons/Button";
import { cn } from "@/lib/utils";
import { useAuth } from "hooks/useAuth";
import { fireEvent } from "lib/ga";
import { useTheme as useNextTheme } from "next-themes";
import { useEffect, useState } from "react";

import { Text } from "../../core/Text";

export const ContentPreview = ({
    content,
    children
}: {
    content: Mix_ContentFragment;
    children: React.ReactNode;
}) => {
    const { theme: nextTheme } = useNextTheme();
    const { openSignInModal } = useAuth();
    const [mounted, setMounted] = useState(false);

    // Prevent hydration mismatch
    useEffect(() => {
        setMounted(true);
    }, []);

    const isDark = nextTheme === "dark";
    const gradientEndColor = isDark
        ? "rgb(19, 18, 18)"
        : "rgba(255, 255, 255, 1)";

    return (
        <div className="relative">
            {children}
            <div className="absolute bottom-0 flex w-full flex-col">
                {mounted && (
                    <div
                        className="relative top-2.5 h-[210px] w-full"
                        style={{
                            background: `linear-gradient(180deg, ${
                                isDark
                                    ? "rgba(19, 18, 18, 0)"
                                    : "rgba(255, 255, 255, 0)"
                            } 0%, ${gradientEndColor} 100%)`
                        }}
                    />
                )}
                <div className="h-10 bg-background" />
                <div className="bg-background">
                    <div className="flex flex-col items-center rounded-lg bg-grey-a100 py-12 md:py-6">
                        <Text
                            className="mb-3 text-center text-base text-text-secondary md:text-sm"
                            variant="body1"
                        >
                            10초 간편 회원가입하고
                            <br />
                            이어서 열람해요!
                        </Text>
                        <Button
                            className="w-[180px]"
                            size="xl"
                            onClick={() => {
                                openSignInModal();

                                fireEvent({
                                    event: "content_signup_click",
                                    params: {
                                        content_id: content.id,
                                        content_url: content.originalurl
                                    }
                                });
                            }}
                        >
                            믹스 회원가입하기
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
